import React from 'react';
import { Link } from 'react-router-dom';
export function NewsfilateFooter() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-white text-gray-900 py-12 border-t border-gray-100" data-id="element-397">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-398">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-399">
          <div className="col-span-1 md:col-span-2" data-id="element-400">
            <div className="mb-4" data-id="element-401">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/debbab01-79d9-49e0-a766-2a2a9aeb34ad/Nf_final.png" alt="Newsfiliate Logo" className="h-10" data-id="element-402" />
            </div>
            <p className="text-gray-600 mb-4 max-w-md" data-id="element-403">
              Helping newsletter creators effortlessly monetize with Amazon
              affiliate deals and promo codes.
            </p>
          </div>
          <div data-id="element-404">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4" data-id="element-405">
              Product
            </h3>
            <ul className="space-y-2" data-id="element-406">
              <li data-id="element-407">
                <a href="#features" className="text-gray-600 hover:text-gray-900" onClick={e => scrollToSection(e, 'features')} data-id="element-408">
                  Features
                </a>
              </li>
              <li data-id="element-409">
                <a href="#how-it-works" className="text-gray-600 hover:text-gray-900" onClick={e => scrollToSection(e, 'how-it-works')} data-id="element-410">
                  How It Works
                </a>
              </li>
              <li data-id="element-411">
                <a href="#pricing" className="text-gray-600 hover:text-gray-900" onClick={e => scrollToSection(e, 'pricing')} data-id="element-412">
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-413">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4" data-id="element-414">
              Company
            </h3>
            <ul className="space-y-2" data-id="element-415">
              <li data-id="element-416">
                <Link to="/" className="text-gray-600 hover:text-gray-900" data-id="element-417">
                  Creator Boost
                </Link>
              </li>
              <li data-id="element-418">
                <a href="https://datadyno.blog" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-419">
                  Blog
                </a>
              </li>
              <li data-id="element-420">
                <a href="https://newsfiliate.creatorboost.ai/doc/newsfiliate-help?page=support" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-421">
                  Support
                </a>
              </li>
              <li data-id="element-422">
                <a href="https://creatorboost.ai/privacy-policy" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-423">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-424">
                <a href="https://creatorboost.ai/terms-of-service" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-425">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-100 text-center text-gray-600 text-sm" data-id="element-426">
          <p data-id="element-427">
            &copy; {new Date().getFullYear()} Newsfiliate. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}